import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a53ff09")

_pushScopeId("data-v-1a53ff09")
const _hoisted_1 = { class: "details-page" }
const _hoisted_2 = { class: "content_ls_margin" }
const _hoisted_3 = { class: "ls-slate-dark" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "content_ls_margin" }
const _hoisted_8 = { class: "band-3" }
const _hoisted_9 = {
  key: 0,
  class: "personal-details"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("h3", null, "Personal Details", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Name")
], -1)
const _hoisted_13 = { class: "col-8" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "LawID number")
], -1)
const _hoisted_16 = { class: "col-8" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "PC holder")
], -1)
const _hoisted_19 = { class: "col-8" }
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Year of admission")
], -1)
const _hoisted_22 = { class: "col-8" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Law Society Member")
], -1)
const _hoisted_25 = { class: "col-8" }
const _hoisted_26 = {
  key: 1,
  class: "employment-details"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Employment Details")
const _hoisted_28 = {
  key: 0,
  class: "row"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Law practice name")
], -1)
const _hoisted_30 = { class: "col-8" }
const _hoisted_31 = {
  key: 1,
  class: "row"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Firm / Organisation name")
], -1)
const _hoisted_33 = { class: "col-8" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Missing information, please ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_38 = {
  key: 2,
  class: "row"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Employment status")
], -1)
const _hoisted_40 = { class: "col-8" }
const _hoisted_41 = {
  key: 2,
  class: "contact-details"
}
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Committee Contact Details")
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee postal address")
], -1)
const _hoisted_45 = { class: "col-8" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Missing information, please ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_50 = { class: "row" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee phone number")
], -1)
const _hoisted_52 = { class: "col-8" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Missing information, please ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee email address")
], -1)
const _hoisted_59 = { class: "col-8" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Missing information, please ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_63 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = { class: "content_ls_margin" }
const _hoisted_66 = { class: "radio-box" }
const _hoisted_67 = /*#__PURE__*/_createVNode("h3", null, "Are your Personal, Employment and Committee Contact details correct?", -1)
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "radio outline" }
const _hoisted_70 = /*#__PURE__*/_createVNode("label", { for: "radioPage2_0" }, "Yes, all details are correct", -1)
const _hoisted_71 = { class: "radio outline" }
const _hoisted_72 = {
  key: 0,
  for: "radioPage2_1"
}
const _hoisted_73 = {
  key: 1,
  for: "radioPage2_1"
}
const _hoisted_74 = { key: 2 }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("No, my personal and/ or practice details are not correct. I will contact the Law Society Registry at "),
  /*#__PURE__*/_createVNode("a", { href: "mailto:registry@lawsociety.com.au" }, "registry@lawsociety.com.au"),
  /*#__PURE__*/_createTextVNode(" to update my details.")
], -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("p", null, " You may proceed with this Expression of Interest. ", -1)
const _hoisted_80 = { key: 3 }
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_83 = /*#__PURE__*/_createTextVNode("In order to continue, please edit your ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" details on this page, then change your selection to 'Yes, all details are correct' to proceed. ")
const _hoisted_86 = {
  key: 0,
  class: "col-4"
}
const _hoisted_87 = { class: "radio outline" }
const _hoisted_88 = /*#__PURE__*/_createVNode("label", { for: "radioPage2_2" }, "No, I want to update my Committee Contact details", -1)
const _hoisted_89 = { key: 0 }
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode("In order to continue, please edit your ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" details on this page, then change your selection to one of the other two options. ")
const _hoisted_94 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_DetailsEdit = _resolveComponent("DetailsEdit")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.pageHeader), 1),
      _hoisted_4
    ]),
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        (_ctx.personalDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode("div", _hoisted_13, [
                  _createVNode("p", null, _toDisplayString(_ctx.personalDetail.displayName), 1)
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("div", _hoisted_16, [
                  _createVNode("p", null, _toDisplayString(_ctx.personalDetail.lawId), 1)
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("div", _hoisted_19, [
                  _createVNode("p", null, _toDisplayString(_ctx.personalDetail?.isPcHolder ? 'Yes' : 'No'), 1)
                ])
              ]),
              (_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode("div", _hoisted_22, [
                      _createVNode("p", null, _toDisplayString(_ctx.personalDetail.admissionYear), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  _createVNode("p", null, _toDisplayString(_ctx.personalDetail.memberDescription), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.employmentDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_26, [
              _createVNode("h3", null, [
                _hoisted_27,
                (!_ctx.isPcHolder)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "btn btn-tertiary sml ml-4",
                      onClick: _cache[1] || (_cache[1] = $event => (_ctx.showEditModal(2)))
                    }, "Edit"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode("div", _hoisted_30, [
                      _createVNode("p", null, _toDisplayString(_ctx.employmentDetail.firmName), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode("div", _hoisted_33, [
                      (_ctx.employmentDetail.firmName)
                        ? (_openBlock(), _createBlock("p", _hoisted_34, _toDisplayString(_ctx.employmentDetail.firmName), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_35, [
                            _hoisted_36,
                            _createVNode("span", {
                              onClick: _cache[2] || (_cache[2] = $event => (_ctx.showEditModal(3))),
                              class: "link"
                            }, "edit"),
                            _hoisted_37
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode("div", _hoisted_40, [
                      _createVNode("p", null, _toDisplayString(_ctx.personalDetail.solicitorTypeDescription), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.committeeContactDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_41, [
              _createVNode("h3", null, [
                _hoisted_42,
                _createVNode("button", {
                  class: "btn btn-tertiary sml ml-4",
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.showEditModal(3)))
                }, "Edit")
              ]),
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode("div", _hoisted_45, [
                  (_ctx.committeeContactDetail.address)
                    ? (_openBlock(), _createBlock("p", _hoisted_46, [
                        _createVNode("pre", null, _toDisplayString(_ctx.getAddressEncoded()), 1)
                      ]))
                    : (_openBlock(), _createBlock("p", _hoisted_47, [
                        _hoisted_48,
                        _createVNode("span", {
                          onClick: _cache[4] || (_cache[4] = $event => (_ctx.showEditModal(3))),
                          class: "link"
                        }, "edit"),
                        _hoisted_49
                      ]))
                ])
              ]),
              _createVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode("div", _hoisted_52, [
                  (_ctx.committeeContactDetail.phone)
                    ? (_openBlock(), _createBlock("p", _hoisted_53, _toDisplayString(_ctx.getPhoneNumber()), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_54, [
                        _hoisted_55,
                        _createVNode("span", {
                          class: "link",
                          onClick: _cache[5] || (_cache[5] = $event => (_ctx.showEditModal(3)))
                        }, "edit"),
                        _hoisted_56
                      ]))
                ])
              ]),
              _createVNode("div", _hoisted_57, [
                _hoisted_58,
                _createVNode("div", _hoisted_59, [
                  (_ctx.committeeContactDetail.email)
                    ? (_openBlock(), _createBlock("p", {
                        key: 0,
                        title: _ctx.committeeContactDetail.email,
                        class: "email"
                      }, _toDisplayString(_ctx.committeeContactDetail.email), 9, ["title"]))
                    : _createCommentVNode("", true),
                  (_ctx.committeeContactDetail.email == '')
                    ? (_openBlock(), _createBlock("p", _hoisted_60, [
                        _hoisted_61,
                        _createVNode("span", {
                          class: "link",
                          onClick: _cache[6] || (_cache[6] = $event => (_ctx.showEditModal(3)))
                        }, "edit"),
                        _hoisted_62
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_63,
    _hoisted_64,
    _createVNode("div", _hoisted_65, [
      _createVNode("div", _hoisted_66, [
        _hoisted_67,
        _createVNode("div", _hoisted_68, [
          _createVNode("div", {
            class: _ctx.isPcHolder ? 'col-4' : 'col-6'
          }, [
            _createVNode("div", _hoisted_69, [
              _withDirectives(_createVNode("input", {
                type: "radio",
                name: "radioPage2",
                id: "radioPage2_0",
                checked: _ctx.eoi.confirmPersonalDetails && _ctx.eoi.confirmEmployeeDetails && _ctx.eoi.confirmCommitteeContactDetails,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.detailsCorrect = $event)),
                value: 0,
                onChange: _cache[8] || (_cache[8] = $event => (_ctx.radioSelect(0)))
              }, null, 40, ["checked"]), [
                [_vModelRadio, _ctx.detailsCorrect]
              ]),
              _hoisted_70
            ])
          ], 2),
          _createVNode("div", {
            class: _ctx.isPcHolder ? 'col-4' : 'col-6'
          }, [
            _createVNode("div", _hoisted_71, [
              _withDirectives(_createVNode("input", {
                type: "radio",
                name: "radioPage2",
                id: "radioPage2_1",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.detailsCorrect = $event)),
                checked: !_ctx.eoi.confirmPersonalDetails && !_ctx.eoi.confirmEmployeeDetails && _ctx.eoi.confirmCommitteeContactDetails,
                value: 1,
                onChange: _cache[10] || (_cache[10] = $event => (_ctx.radioSelect(1)))
              }, null, 40, ["checked"]), [
                [_vModelRadio, _ctx.detailsCorrect]
              ]),
              (_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("label", _hoisted_72, "No, my personal and/ or practice details are not correct."))
                : _createCommentVNode("", true),
              (!_ctx.isPcHolder)
                ? (_openBlock(), _createBlock("label", _hoisted_73, "No, I want to update my details"))
                : _createCommentVNode("", true),
              (_ctx.isPcHolder && !(_ctx.eoi.confirmPersonalDetails && _ctx.eoi.confirmEmployeeDetails))
                ? (_openBlock(), _createBlock("div", _hoisted_74, [
                    _hoisted_75,
                    _hoisted_76,
                    _hoisted_77,
                    _hoisted_78,
                    _hoisted_79
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isPcHolder && !(_ctx.eoi.confirmPersonalDetails && _ctx.eoi.confirmEmployeeDetails))
                ? (_openBlock(), _createBlock("div", _hoisted_80, [
                    _hoisted_81,
                    _hoisted_82,
                    _createVNode("p", null, [
                      _hoisted_83,
                      _createVNode("span", {
                        onClick: _cache[11] || (_cache[11] = $event => (_ctx.showEditModal(2))),
                        class: "link"
                      }, "Employment"),
                      _hoisted_84,
                      _createVNode("span", {
                        onClick: _cache[12] || (_cache[12] = $event => (_ctx.showEditModal(3))),
                        class: "link"
                      }, "Committee Contact"),
                      _hoisted_85
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          (_ctx.isPcHolder)
            ? (_openBlock(), _createBlock("div", _hoisted_86, [
                _createVNode("div", _hoisted_87, [
                  _withDirectives(_createVNode("input", {
                    type: "radio",
                    name: "radioPage2",
                    id: "radioPage2_2",
                    checked: _ctx.isPcHolder && _ctx.eoi.confirmPersonalDetails && _ctx.eoi.confirmPersonalDetails && !_ctx.eoi.confirmCommitteeContactDetails,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (_ctx.detailsCorrect = $event)),
                    value: 2,
                    onChange: _cache[14] || (_cache[14] = $event => (_ctx.radioSelect(2)))
                  }, null, 40, ["checked"]), [
                    [_vModelRadio, _ctx.detailsCorrect]
                  ]),
                  _hoisted_88,
                  (!_ctx.eoi.confirmCommitteeContactDetails && _ctx.isPcHolder)
                    ? (_openBlock(), _createBlock("div", _hoisted_89, [
                        _hoisted_90,
                        _hoisted_91,
                        _createVNode("p", null, [
                          _hoisted_92,
                          _createVNode("span", {
                            onClick: _cache[15] || (_cache[15] = $event => (_ctx.showEditModal(3))),
                            class: "link"
                          }, "Committee Contact"),
                          _hoisted_93
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_94,
    _hoisted_95,
    (_ctx.showModalDetailsEdit)
      ? (_openBlock(), _createBlock(_component_DetailsEdit, {
          key: 0,
          pDetails: _ctx.personalDetail,
          "onUpdate:pDetails": _cache[16] || (_cache[16] = $event => (_ctx.personalDetail = $event)),
          eDetails: _ctx.employmentDetail,
          "onUpdate:eDetails": _cache[17] || (_cache[17] = $event => (_ctx.employmentDetail = $event)),
          cDetails: _ctx.committeeContactDetail,
          "onUpdate:cDetails": _cache[18] || (_cache[18] = $event => (_ctx.committeeContactDetail = $event)),
          myCommittees: _ctx.myCommittees,
          "onUpdate:myCommittees": _cache[19] || (_cache[19] = $event => (_ctx.myCommittees = $event)),
          onClose: _cache[20] || (_cache[20] = $event => {_ctx.showModalDetailsEdit = false; _ctx.canSubmitCheck();}),
          editType: _ctx.editType
        }, null, 8, ["pDetails", "eDetails", "cDetails", "myCommittees", "editType"]))
      : _createCommentVNode("", true)
  ]))
})